const getError = require('./get-error')
const generatePurchaseOrder = require('./generate-purchase-order')
const generateSalesOrder = require('./generate-sales-order')
const { transformProducts, groupProductsByWarehouse } = require('./transform-product')
const generateStockTransferOrder = require('./generate-stock-transfer-order')
const generateReturnShipment = require('./generate-return-shipment')

module.exports = {
  getError,
  generatePurchaseOrder,
  generateSalesOrder,
  transformProducts,
  groupProductsByWarehouse,
  generateStockTransferOrder,
  generateReturnShipment
}
